export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8508.616a2e1a.jpg";